import React from 'react';
import {Card, ListGroup} from "react-bootstrap";

const Documentation = () => {
    return (
        <div className="documentation-page">
            <div className="token-header">
                {/*<img src={LogoName} alt="logo"/>*/}
                <span>
                    <h3> VAT IT Documentation</h3>
                </span>
            </div>
            <Card className="card-body">
                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <div className="list-item-container">
                            <a href="/auth">
                                <span className="step-header">
                                    <strong>Get Your Token </strong>
                                </span>
                                    <span className="step-content">
                                    A page with instructions on how to acquire a JWT token.
                                </span>
                            </a>
                        </div>
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <div className="list-item-container">
                            <a href="/documentation/invoice-submission">
                                <span className="step-header">
                                    <strong>Invoice Submissions </strong>
                                </span>
                                <span className="step-content">
                                    A page detailing the POST requests you can integrate with
                                </span>
                            </a>
                        </div>
                    </ListGroup.Item>
                </ListGroup>
            </Card>
        </div>
    )
}

export default Documentation;
